var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VTest',{attrs:{"default-test":_vm.defaultTest,"test-diffs":_vm.testDiffs,"component":_vm.VPrice,"i18n":"substore"}})
}
var staticRenderFns = []

export { render, staticRenderFns }